import * as React from 'react';
import * as Layout from '../../../../common/styles/Layout';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import { Messages } from '../../../../../gen-src/Localize';
import { AppState } from '../../../../app/state/AppState';
import { DropdownBlueButton, DropdownDefaultButton, FilteringListClass } from '../../../styles/FilterStyles';
import { FilterTypes } from '../../../models/FilterTypes';
import { updateFilter } from '../../../actions/UpdateFilterAction';
import { QuickFilter, QuickFilterDispatchProps, QuickFilterOwnProps, QuickFilterStateProps } from '../QuickFilter';
import { RouteComponentProps } from 'react-router-dom';
import { FilterAllOption } from '../../../state/FilterState';
import { CommonStyles } from '../../../../common/styles/CommonStyles';

export type ModifiedTimeFilterProps = QuickFilterOwnProps & QuickFilterStateProps & QuickFilterDispatchProps & RouteComponentProps;

export const ModifiedTimeFilterLabelTestID = 'ModifiedTimeFilter';

interface PredefinedTime {
  name: string;
  value: string;
}

export enum ModifiedTimeOption {
  today = 'today',
  yesterday = 'yesterday',
  last7days = 'last_7_days',
  last30days = 'last_30_days',
  last90days = 'last_90_days',
}

export class ModifiedTimeFilter extends QuickFilter<ModifiedTimeFilterProps> {
  private prevValue = this.props.filterSelected.id.toString(); //used to track changes in the value selected for telemetry

  public render() {
    const filterList: PredefinedTime[] = [
      { name: Messages.TimeFilter_any_option(), value: FilterAllOption },
      { name: Messages.TimeFilter_today_option(), value: ModifiedTimeOption.today },
      { name: Messages.TimeFilter_yesterday_option(), value: ModifiedTimeOption.yesterday },
      { name: Messages.TimeFilter_7days_option(), value: ModifiedTimeOption.last7days },
      { name: Messages.TimeFilter_30days_option(), value: ModifiedTimeOption.last30days },
      { name: Messages.TimeFilter_90days_option(), value: ModifiedTimeOption.last90days },
    ];
    const filterValues = this.getFilterValues(filterList);
    const selectedFilterName = this.getSelectedFilterName(filterList);
    const buttonStyle =
      this.props.filterSelected.id === FilterAllOption ? CommonStyles.Button.baseButtonStyle : CommonStyles.Button.blueButtonStyle;
    const buttonClass = this.props.filterSelected.id === FilterAllOption ? DropdownDefaultButton : DropdownBlueButton;
    return (
      <SingleSelectDropdown
        label=""
        list={<List items={filterValues} className={FilteringListClass} />}
        style={{ marginLeft: '10px', ...buttonStyle }}
        type={DropdownButtonType.Outline}
        value={this.props.filterSelected.id}
        onChange={(value) => this.onValueChange(value)}
        className={buttonClass}
        aria-label={Messages.ModifiedTime_SubTitle() + ' ' + selectedFilterName}
      >
        <span data-tb-test-id={ModifiedTimeFilterLabelTestID}>
          {this.props.filterSelected.id === FilterAllOption && <span>{Messages.ModifiedTime_SubTitle() + ' '}</span>}
          <b>{selectedFilterName}</b>
        </span>
      </SingleSelectDropdown>
    );
  }

  private getFilterValues(filters: PredefinedTime[]): ListItem[] {
    const list: ListItem[] = [];

    filters.forEach((item) => {
      list.push({
        content: (
          <div className={Layout.flexH}>
            <div className={Layout.flexAuto}>{item.name}</div>
          </div>
        ),
        value: item.value,
      });
    });
    return list;
  }

  private getSelectedFilterName(timePeriod: PredefinedTime[]) {
    return timePeriod.find((x) => x.value === this.props.filterSelected.id)?.name;
  }

  private onValueChange(id: string): void {
    this.sendFiltersUpdatedTelemetryEvent(id, this.prevValue, FilterTypes.modifiedTime, this.props.contentType);
    this.onDropDownValueChanged(id, FilterTypes.modifiedTime);
    this.prevValue = id.toString();
  }
}

const mapStateToProps = (state: AppState) => ({
  filterSelected: state.filters.query.modifiedTime,
  allFilterValues: state.filters.query,
  contentType: state.search.selectedContentTypeFilterValue,
  mixedContentResults: state.search.mixedContentType.searchResult,
  singleContentResults: state.singleContentType.searchResults,
  isLoadingFilterContent: state.filters.isLoadingFilterContent,
  searchTerm: state.search.searchTerm,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      updateFilter,
    },
    dispatch
  );

const ModifiedTimeFilterWithRouter = withRouter(ModifiedTimeFilter);

export const ConnectedModifiedTimeFilter: React.ComponentClass<QuickFilterOwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModifiedTimeFilterWithRouter);
